export default "__VITE_ASSET__6fb30569__"